import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import { apiCall } from "../../../../API/apiCall";
import { instituteAddPlanSchema } from "../../../../schema/schema";
import Loader from "../../../loader/Loader";
import { toast } from "react-toastify";

const AssignPlan = ({ handleCloseModal, getAllInstitutes, data }) => {
  const [selectedPlan, setSelectedPlan] = useState();
  const [loading, setLoading] = useState({
    isLoading: true,
    type: "",
  });
  const [plans, setPlans] = useState([]);
  const [modalType, setModalType] = useState(
    data.isPlanCreated ? "editPlan" : "assignPlan"
  );

  const [formData, setFormData] = useState({
    duration: data.origin === "qrcode" ? 3 : "",
    quantity: data.origin === "qrcode" ? 5 : "",
    price: "",
  });

  const [formError, setFormError] = useState({});

  useEffect(() => {
    const getAllPlans = async () => {
      try {
        setLoading({ isLoading: true, type: "getPlans" });
        const response = await apiCall({
          url: "/institute/plan",
          method: "GET",
          params: {
            isDeleted: false,
            limit: false,
          },
        });

        setPlans(response?.data?.data);
        if (data.origin === "qrcode") {
          const selectedPlanData = response?.data?.data?.find(
            (plan) => plan?.planType === "complimentary"
          );
          setSelectedPlan(selectedPlanData);
        }
      } catch (error) {
        console.log("Error : ", error);
      } finally {
        setLoading({ isLoading: false, type: "" });
      }
    };
    getAllPlans();
  }, []);

  useEffect(() => {
    const getPlanDetails = async () => {
      try {
        const response = await apiCall({
          url: "/institute/get-institute-plan-details",
          method: "GET",
          params: {
            email: data?.email,
          },
        });

        const selectedPlanData = plans.find(
          (plan) => plan?._id === response.data?.institutePlanId?._id
        );

        setSelectedPlan(selectedPlanData);

        const payload = {
          duration: response?.data?.duration?.toString(),
          quantity: response?.data?.memberQuantity,
          price: response?.data?.institutePlanTotalPrice?.toFixed(2),
          planId: selectedPlanData?._id,
          status: response?.data?.status,
        };

        setFormData({
          ...payload,
          originalData: payload,
        });
      } catch (error) {
        console.log("Error : ", error);
      } finally {
        setLoading({ isLoading: false, type: "" });
      }
    };
    if (data?.isPlanCreated && plans.length) {
      setLoading({ isLoading: true, type: "getPlanDetails" });
      getPlanDetails();
    }
  }, [plans]);

  const handlePlanChange = (selectedValue) => {
    const selectedPlanData = plans.find((plan) => plan.name === selectedValue);
    setSelectedPlan(selectedPlanData);
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const frequencyMultiplier = {
    monthly: 1,
    yearly: 12,
  };

  function calculatePlanPrice(
    planDuration,
    quantity,
    pricePerQuantity,
    frequency
  ) {
    console.log("FFFFFFFFF L : ", frequency);
    frequency = frequency.toLowerCase();

    if (frequency !== "monthly" && frequency !== "yearly") {
      throw new Error("Frequency must be either 'monthly' or 'yearly'");
    }

    // Calculate total price
    let totalPrice = planDuration * quantity * pricePerQuantity;

    return Number(totalPrice.toFixed(2));
  }

  useEffect(() => {
    if (selectedPlan) {
      const durationValue = parseFloat(formData?.duration);
      const quantityValue = parseFloat(formData?.quantity);

      if (
        !isNaN(durationValue) &&
        !isNaN(quantityValue) &&
        durationValue > 0 &&
        quantityValue > 0
      ) {
        console.log("TTTTTTTTTTTTT");
        // const calculatedPrice = (
        //   durationValue *
        //   quantityValue *
        //   selectedPlan?.pricePerQty *
        //   frequencyMultiplier[selectedPlan?.frequency]
        // ).toFixed(2);

        const calculatedPrice = calculatePlanPrice(
          durationValue,
          quantityValue,
          selectedPlan?.pricePerQty,
          selectedPlan?.frequency
        );

        console.log("Calculated Price : ", calculatedPrice);
        handleInputChange("price", calculatedPrice);
      } else {
        handleInputChange("price", null);
      }
    }
  }, [formData?.duration, formData?.quantity, selectedPlan]);

  const handleQuantityChange = (name, value) => {
    handleInputChange(name, value);

    if (selectedPlan?.pricePerQty && formData?.duration && formData?.quantity)
      handleInputChange("price", parseInt(value) * selectedPlan?.pricePerQty);
  };

  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: 200,
        overflowY: "auto",
      },
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { instituteName } = data || {};
    const { originalData, ...updatedData } = formData;
    let payload = {};
    const url = "institute";

    const validateAssignPlan = () => {
      const { duration, quantity } = formData;
      const error = instituteAddPlanSchema({
        instituteName,
        planId: selectedPlan?._id,
        duration,
        quantity,
      });

      if (selectedPlan?.minimumQty > parseInt(formData?.quantity)) {
        setFormError({
          quantity: `Quantity should be greater than or equal to ${selectedPlan?.minimumQty} for this plan `,
        });
        return false;
      }

      if (Object.keys(error).length !== 0) {
        setFormError(error);
        return false;
      }
      return true;
    };
    const { duration, quantity, price } = formData;

    const buildPayload = () => {
      if (modalType === "assignPlan") {
        const { duration, quantity, price } = formData;
        return {
          institutePlanId: selectedPlan?._id,
          duration,
          quantity,
          institutePlanTotalPrice: price,
          instituteEmail: data?.email,
        };
      } else {
        if (selectedPlan?._id?.toString() !== formData.planId?.toString()) {
          payload["institutePlanId"] = selectedPlan?._id;
        }

        Object.entries(updatedData).forEach(([key, value]) => {
          if (key !== "planId" && value !== originalData?.[key]) {
            payload[key] = value;
          }
        });
        return { ...payload, instituteEmail: data?.email };
      }
    };

    if (!validateAssignPlan()) return;

    payload = buildPayload();
    const config = {
      url: `${url}/${
        modalType === "assignPlan"
          ? "add-plan-to-institute"
          : "edit-institute-subscription"
      }`,
      method: modalType === "assignPlan" ? "POST" : "PATCH",
      data: payload,
    };

    try {
      setLoading({ isLoading: true, type: "submit" });
      const response = await apiCall(config);

      if (response.success) {
        toast.success(response.message);
        getAllInstitutes();
        handleCloseModal();
      }
    } catch (err) {
      console.error("API call failed: ", err);
    } finally {
      setLoading({ isLoading: false, type: "" });
    }
  };

  return (
    <>
      {loading.isLoading && loading.type === "getPlanDetails" && <Loader />}
      <Box
        sx={{
          maxWidth: "100%",
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 1,
          overflow: "auto",
        }}
      >
        <Typography variant="h6" gutterBottom>
          {modalType === "editPlan" ? "Edit Plan" : "Assign Plan"}
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Institute Name *"
            name="instituteName"
            value={data?.instituteName || ""}
            error={!!formError?.instituteName}
            helperText={formError?.instituteName}
            fullWidth
            margin="normal"
            sx={{ mb: 2 }}
            inputProps={{ readOnly: true }}
            disabled
          />
          <FormControl fullWidth error={!!formError?.frequency}>
            <InputLabel>Select Plan *</InputLabel>
            <Select
              value={selectedPlan?.name || ""}
              label="Select plan"
              disabled={formData.originalData?.status === "true"}
              onChange={(e) => handlePlanChange(e.target.value)}
              endAdornment={
                loading.isLoading &&
                loading.type === "getPlans" &&
                !plans.length ? (
                  <CircularProgress
                    size={24}
                    style={{ position: "absolute", right: 30 }}
                  />
                ) : null
              }
              MenuProps={menuProps}
            >
              {plans?.map((plan, index) => (
                <MenuItem key={index} value={plan?.name}>
                  {plan.name}
                </MenuItem>
              ))}
            </Select>
            {formError?.planId && (
              <FormHelperText sx={{ color: "#d32f2f" }}>
                {formError?.planId}
              </FormHelperText>
            )}
          </FormControl>
          <Box display="flex" justifyContent="space-between">
            <TextField
              label={"Duration *"}
              name="duration"
              type="number"
              disabled={formData?.originalData?.status === "true"}
              value={formData?.duration || ""}
              onChange={(e) => handleQuantityChange("duration", e.target.value)}
              error={!!formError?.duration}
              helperText={formError?.duration}
              inputProps={{ min: 1, step: 1 }}
              margin="normal"
              sx={{ mr: 2 }}
              fullWidth
            />
            <TextField
              label={"Frequency"}
              name="duration"
              type="text"
              value={selectedPlan?.frequency || ""}
              onChange={(e) => handleInputChange("frequency", e.target?.value)}
              fullWidth
              disabled
              inputProps={{ readOnly: true }}
              margin="normal"
            />
          </Box>

          <Box display="flex" justifyContent="space-between">
            <TextField
              label={"Quantity *"}
              name="quantity"
              type="number"
              value={formData?.quantity || ""}
              onChange={(e) => handleInputChange("quantity", e.target?.value)}
              error={!!formError?.quantity}
              helperText={formError?.quantity}
              fullWidth
              inputProps={{ min: 1, step: 1 }}
              margin="normal"
              sx={{ mr: 2 }}
              disabled={data.origin === "qrcode"}
            />

            <TextField
              label={"Price"}
              name="price"
              type="text"
              value={data.origin === "qrcode" ? "N/A" : formData?.price || ""}
              fullWidth
              disabled
              inputProps={{ readOnly: true }}
              margin="normal"
            />
          </Box>

          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              variant="outlined"
              onClick={handleCloseModal}
              sx={{ color: "red" }}
            >
              Cancel
            </Button>
            <Button variant="contained" sx={{ ml: 2 }} type="submit">
              {modalType === "assignPlan" ? "Assign" : "Update"}
              {loading.isLoading && loading.type === "submit" && (
                <CircularProgress
                  size={24}
                  sx={{ color: "white", marginRight: 0, marginLeft: 0.5 }}
                />
              )}
            </Button>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default AssignPlan;
